/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

// import { ContainerClient } from '@azure/storage-blob';
import { naturalSort } from '../utils';

/** I did a bit of typescript magic to enforce that sas_keys has only READ and LIST permissions, and won't expire until the year 3000. */
type SasKeyWithReadListPermissions = `?sp=rl&${string}&se=3${string}`;

/** This list MUST be for READ and LIST, and no more, and expiry */
const sas_keys = {
  // Azure gives you a URL with a SAS key, which is a long string that gives you access to the files in the container.
  // I've split the URL into two parts, the base and the params, just to make it easy to set the filename
  // To view in the browser:
  // https://portal.azure.com/#@medpearl.onmicrosoft.com/resource/subscriptions/3aa3cb4c-e4d0-4711-b90f-a9a95e329ade/resourceGroups/rg-medpearl-dev/providers/Microsoft.Storage/storageAccounts/stmedpearldev01/storagebrowser
  'test-patients': {
    base: 'https://stmedpearldev01.blob.core.windows.net/test-patients',
    params:
      '?sp=rl&st=2025-02-19T07:24:05Z&se=3025-02-19T15:24:05Z&spr=https&sv=2022-11-02&sr=c&sig=oF%2BwlFIEDGBTwGhg%2Fy6BgdVvatHPHEzxZoYcbLBrcjs%3D',
  },
  'auto-contextualization': {
    base: 'https://stmedpearldev01.blob.core.windows.net/auto-contextualization',
    params:
      '?sp=rl&st=2025-04-02T05:20:35Z&se=3025-04-02T13:20:35Z&spr=https&sv=2024-11-04&sr=c&sig=bAYVj8QIVyFWfUeqJVuCKZi8T3LQeLwSGTX7ZsPrTAI%3D',
  },
} as const satisfies Record<string, { base: string; params: SasKeyWithReadListPermissions }>;

/** Get a stringlist of the files with the given extension, minus the extension */
export async function azureListOfFiles(
  folder: string,
  container: keyof typeof sas_keys,
  extension = 'json'
): Promise<string[]> {
  const sasUrl = sas_keys[container];
  // lazy load @azure/storage-blob module
  const { BlobServiceClient } = await import('@azure/storage-blob');
  // create the BlobServiceClient object which will be used to create a container client
  const blobServiceClient = new BlobServiceClient(sasUrl.base + sasUrl.params);
  // get a reference to a container
  const containerClient = blobServiceClient.getContainerClient(folder);
  let blobs = [];
  // Don't get files in subfolders, only the folder specified
  for await (const blob of containerClient.listBlobsFlat()) {
    if (blob.name.endsWith(`.${extension}`)) {
      blobs.push(blob.name.slice(0, -extension.length - 1));
    }
  }
  blobs = naturalSort(blobs);
  return blobs;
}

// export async function downloadBlobToString(containerClient: ContainerClient, blobName: string) {
//   const blobClient = containerClient.getBlobClient(blobName);

//   const downloadBlockBlobResponse = await blobClient.download();
//   const downloaded = await blobToString(await downloadBlockBlobResponse.blobBody);
//   return downloaded;

//   async function blobToString(blob: Blob | undefined): Promise<string> {
//     if (!blob) return Promise.reject('No blob');
//     const fileReader = new FileReader();
//     return new Promise<string>((resolve, reject) => {
//       fileReader.onloadend = (ev: any) => {
//         resolve(ev.target!.result);
//       };
//       fileReader.onerror = reject;
//       fileReader.readAsText(blob);
//     });
//   }
// }

export function azureDownload(filename: string, container: keyof typeof sas_keys) {
  const sasUrl = sas_keys[container];
  // // create the BlobServiceClient object which will be used to create a container client
  // const blobServiceClient = new BlobServiceClient(sasUrl);
  // // get a reference to a container
  // const containerClient = blobServiceClient.getContainerClient('.');
  // return downloadBlobToString(containerClient, filename);
  // Construct the full URL to the blob including the SAS token if needed
  const url = `${sasUrl.base}/${filename}${sasUrl.params}`;
  console.log('sharedcomponents azure download url', url);

  // Use the Fetch API to download the blob
  return fetch(url, {
    headers: {
      'Cache-Control': 'must-revalidate',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
      'Access-Control-Allow-Headers': 'Content-Type',
    },
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.text(); // or response.blob() if you're dealing with binary data
    })
    .catch((error) => {
      console.error('There has been a problem with your fetch operation:', error);
      throw error;
    });
}

export async function azureDownloadTestPatient(filename: string) {
  return await azureDownload(filename + '.json', 'test-patients');
}

export async function azureDownloadKnownAcronyms() {
  return await azureDownload('acronyms.json', 'auto-contextualization');
}
